<template>
  <div class="bg">
    <div class="page-bg"></div>

    <mu-list class="list animated slideInUp">
      <mu-list-item
        v-for="item in data.chapter_lists"
        :key="item.id"
        :ripple="false"
        :to="{
          path: getPath,
          query: {
            chapter_id: item.id,
            is_visible: $route.query.is_visible,
            allow_practise: $route.query.allow_practise,
          },
        }"
        class="item"
        button
      >
        <mu-list-item-title>
          {{ item.title }}
        </mu-list-item-title>

        <mu-list-item-action>
          <mu-icon value="chevron_right"></mu-icon>
        </mu-list-item-action>
      </mu-list-item>
    </mu-list>
  </div>
</template>

<script>
import { fetchCourseChapterLists } from '@/api/index'

export default {
  components: {},
  data() {
    return {
      type: 1,
      data: {},
      info: {
        name: null,
        path: null,
      },
      breadcrumbsArr: [],
    }
  },

  beforeRouteUpdate() {
    console.log('beforeRouteUpdate')
    this.init()
  },

  computed: {
    getPath() {
      let path = ''
      switch (this.type) {
        case 1:
          path = '/online-course'
          break
        case 2:
          path = '/module-exam'
          break
      }
      if (path === '') {
        console.error(
          "CourseChapterLists.vue methods.init()::'path' is empty string"
        )
      }
      return path
    },
  },

  mounted() {
    // this.type = this.$root.$data.navType
    this.type = Number(this.$route.query.type)
    this.init()
  },

  methods: {
    async init() {
      const params = {}
      this.data = await fetchCourseChapterLists(params)

      // this.info.name = this.data.title

      // this.$setHtmlTitle(this.info.name)
    },
  },
}
</script>

<style lang="scss" scoped>
.page-bg {
  position: fixed;
  width: 100%;
  height: 130px;
  background-image: url('../assets/images/page-bg.png');
  background-size: 100% 100%;
  z-index: 1;
}

.list {
  position: relative;
  z-index: 2;
  margin: 0 16px;
  width: calc(100% - 24px);
  margin-top: 16px;
  top: 30px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 6px 1px rgba(210, 210, 210, 0.8);
  padding: 0;
  .item {
    margin: 0;
    height: 48px;
    border-bottom: 1px solid #eee;
    .mu-item-wrapper .mu-item .mu-item-title {
      color: #666;
      &:before {
        content: '';
        width: 3px;
        height: 14px;
        background: #2287c2;
        display: inline-block;
        margin-right: 2px;
        position: relative;
        top: 1px;
      }
    }
  }
}
</style>
